import { useState, useEffect } from 'react'
import { WidgetList } from '../components/dashboard_widget/list'
import {
  Filter,
  List,
  SearchInput,
  SelectInput,
  useGetList,
  Datagrid,
  useRecordContext,
} from 'react-admin'
import {
  Grid,
  Typography,
  Chip,
  Box,
  Tabs,
  TabPanel,
  Tab,
} from '@material-ui/core'
import moment from 'moment'
import {
  WarningAmber,
  QueryBuilder,
  List as ListIcon,
  GridView,
} from '@mui/icons-material'
import config from '../config'

const choices = async (setCoproManagers) => {
  const response = await fetch(
    config.API_V1 + '/dashboard_copromanager/copro_managers/'
  )
  const results = await response.json()
  if (response) setCoproManagers(results)
}

const TicketListMaFilter = (props) => {
  const [coproManagers, setCoproManagers] = useState([])
  useEffect(() => {
    choices(setCoproManagers)
  }, [])

  return (
    <Filter {...props}>
      <SearchInput
        source="copro_code"
        sx={{
          marginBottom: '4px',
        }}
        alwaysOn
      />
      <SelectInput
        className={`${
          window.context['user_type'].includes('Admin') ? '' : 'd-none'
        } dashboard-filter-select`}
        sx={{
          width: '250px',
        }}
        label="Copro manager"
        source="copro_manager_id"
        allowEmpty
        emptyValue={null}
        choices={coproManagers}
        alwaysOn
      />
    </Filter>
  )
}

const DashboardWidgets = (props) => {
  const [filter] = useState({
    perPage: {
      VISITE_PROGRAMMER: 15,
    },
  })
  const sort = { field: 'id', order: 'ASC' }
  let { data, isLoading } = useGetList('dashboard_copromanager', {
    filter: filter,
    pagination: { page: 1, perPage: 5 },
    sort,
  })
  if (isLoading === true) return <span>Loading...</span>
  data = Object.values(data)
  let categoryzedProcesses = []
  if (data && data.length) {
    const [{ list }] = data
    list.forEach((row) => {
      if (!categoryzedProcesses[row.tag]) categoryzedProcesses[row.tag] = [row]
      else categoryzedProcesses[row.tag].push(row)
    })
  }

  return Object.keys(categoryzedProcesses).map((key) => (
    <Grid p={2}>
      <Typography variant="h5" style={{ color: 'grey', padding: '16px' }}>
        {key}
      </Typography>
      <WidgetList
        resource={props.resource}
        processes={categoryzedProcesses[key]}
      />
    </Grid>
  ))
}

const ContractsField = () => {
  const record = useRecordContext()
  const visitDate = moment(record.visits_date)
  const meetingDate = moment(record.meetings_date)

  return (
    <Grid container spacing={1}>
      <Grid container item xs={6}>
        {/* <Grid item xs={12}>
          Visits
        </Grid> */}
        <Grid item xs={12}>
          {visitDate.isValid() ? (
            visitDate.isBefore() ? (
              <Typography color="error">{visitDate.format('DD/MM')}</Typography>
            ) : (
              visitDate.format('DD/MM')
            )
          ) : (
            <Typography color="secondary">To do</Typography>
          )}
        </Grid>
      </Grid>
      <Grid container item xs={6}>
        <Grid item xs={12}>
          {/* <Grid item xs={12}>
            contracts
          </Grid> */}
          {meetingDate.isValid() ? (
            meetingDate.format('DD/MM')
          ) : (
            <Typography color="secondary">To do</Typography>
          )}
        </Grid>
      </Grid>
    </Grid>
  )
}

const CoproField = () => {
  const record = useRecordContext()

  return (
    <Grid container>
      <Grid container item xs={6}>
        {/* <Grid item xs={12}>
          copro_code
        </Grid> */}
        <Grid item xs={12}>
          {record.copro_code}
        </Grid>
      </Grid>
    </Grid>
  )
}

const InvoicesField = () => {
  const {
    invoices_pending_approval_due_count,
    invoices_pending_approval_count,
  } = useRecordContext()

  return (
    <Grid container>
      <Grid container item xs={6}>
        <Grid item xs={12}>
          <Chip
            size="small"
            label={invoices_pending_approval_count}
            style={{
              backgroundColor:
                invoices_pending_approval_due_count > 0 ? 'red' : 'inherits',
              color:
                invoices_pending_approval_due_count > 0 ? 'white' : 'inherits',
            }}
          />
        </Grid>
      </Grid>
    </Grid>
  )
}

const InfoField = () => {
  const { missing_infos } = useRecordContext()
  if (true == missing_infos)
    return (
      <div
        style={{
          backgroundColor: '#FCCC60',
          width: '23px',
          height: '23px',
          borderRadius: '100%',
          display: 'block',
        }}
      />
    )

  return (
    <div
      style={{
        backgroundColor: 'green',
        width: '23px',
        height: '23px',
        borderRadius: '100%',
        display: 'block',
      }}
    />
  )
}

const ActionsField = () => {
  const { t_action_pac, t_internal } = useRecordContext()

  return (
    <Grid container spacing={1}>
      <Grid item>
        <Chip size="small" label={t_action_pac} />
      </Grid>
      <Grid item>
        <Chip size="small" label={t_internal} />
      </Grid>
    </Grid>
  )
}

const TicketUrgentInterventions = () => {
  const { t_urgent_count, t_urgent_overdue_count } = useRecordContext()

  return (
    <Grid container spacing={1}>
      <Grid item>
        <Chip size="small" label={t_urgent_count} />
      </Grid>
      {t_urgent_overdue_count > 0 && (
        <Grid item>
          <Chip
            size="small"
            label={t_urgent_overdue_count}
            style={{
              backgroundColor: 'red',
              color: 'white',
            }}
          />
        </Grid>
      )}
    </Grid>
  )
}

const AGsField = () => {
  const { ag_date_last, ag_date_next } = useRecordContext()
  const ag_date_last_moment = moment(ag_date_last)
  const ag_date_next_moment = moment(ag_date_next)
  if (!ag_date_next_moment.isValid() && !ag_date_last_moment.isValid())
    return (
      <WarningAmber
        style={{
          color: 'red',
        }}
      />
    )

  return ag_date_last_moment.isBefore('9 months') &&
    !ag_date_next_moment.isValid() ? (
    <QueryBuilder
      style={{
        color: '#ffc107',
      }}
    />
  ) : ag_date_last_moment.isBefore('12 months') &&
    !ag_date_next_moment.isValid() ? (
    <WarningAmber
      style={{
        color: 'red',
      }}
    />
  ) : (
    <Typography
      style={{
        color: 'green',
        fontSize: '12px',
      }}
    >
      {ag_date_last_moment.format('D-MMM')}
    </Typography>
  )
}

const TicketLegalField = () => {
  const { t_legal_count, t_legal_overdue_count } = useRecordContext()

  return (
    <Grid container spacing={1}>
      <Grid item>
        <Chip size="small" label={t_legal_count} />
      </Grid>
      {t_legal_overdue_count > 0 && (
        <Grid item>
          <Chip
            size="small"
            label={t_legal_overdue_count}
            style={{
              backgroundColor: 'red',
              color: 'white',
            }}
          />
        </Grid>
      )}
    </Grid>
  )
}

export const CoproManagerDashboardList = () => (
  <List
    exporter={false}
    filters={<TicketListMaFilter />}
    actions={null}
    title={null}
    resource="dashboard_copromanager/alpha"
    perPage={35}
  >
    <Datagrid
      bulkActionButtons={false}
      sx={{
        ' .MuiTypography-root, .MuiGrid-root, .MuiChip-label': {
          fontSize: '12px',
        },
      }}
    >
      <CoproField source="Copro" />
      <InfoField />
      <ContractsField source="contracts_cs" />
      <ActionsField source="actions_cm" />
      <InvoicesField source="invoices" />
      <TicketUrgentInterventions source="urgent_interventions" />
      <AGsField source="ag" />
      <TicketLegalField source="ticket_legal" />
    </Datagrid>
  </List>
)

/**
 * This function render the widget list for copro managers.
 *
 * @see https://marmelab.com/react-admin/List.html#perpage-pagination-size The filter perPage is a workarround because we can't
 * define this as a perPage Object given that it's changed to a an array to express the range
 *
 * @param {*} props
 *
 * @returns List
 */
export const CoproManagerDashboardWidgets = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    exporter={false}
    filters={<TicketListMaFilter />}
    pagination={null}
    actions={null}
    title={null}
  >
    <DashboardWidgets />
  </List>
)

export const CoproManagerDashboardMain = (props) => {
  const [value, setValue] = useState(0)

  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="Tab view dashboard"
          variant="fullWidth"
        >
          <Tab icon={<ListIcon />} />
          <Tab icon={<GridView />} />
        </Tabs>
      </Box>
      {value === 0 && <CoproManagerDashboardList {...props} />}
      {value === 1 && <CoproManagerDashboardWidgets {...props} />}
    </Box>
  )
}
